import { Component, inject } from '@angular/core';
import { GlobalSidenavService } from '../global-sidenav.service';
import { PRIMENG_MODULES } from '@shared/primeng';

@Component({
	selector: 'app-global-navbar',
	imports: [...PRIMENG_MODULES],
	templateUrl: './global-navbar.component.html',
	styleUrl: './global-navbar.component.scss',
})
export class GlobalNavbarComponent {
	public globalSidenavService = inject(GlobalSidenavService);
}
